export default __webpack_public_path__ + "static/media/img_muslinTwoBunnyEars_yg_p.b485b904.jpg";